var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1795 7.13233L14.9744 2.82583C14.4615 2.31316 13.7436 2.00555 12.9231 2.00555H6.8718C5.33333 1.90301 4 3.23598 4 4.77401V19.129C4 20.667 5.23077 22 6.8718 22H17.1282C18.6667 22 20 20.7696 20 19.129V9.08051C20 8.36276 19.6923 7.64501 19.1795 7.13233ZM8.92308 10.1059H12C12.4103 10.1059 12.8205 10.4135 12.8205 10.9262C12.8205 11.4388 12.5128 11.7464 12 11.7464H8.92308C8.51282 11.7464 8.10256 11.4388 8.10256 10.9262C8.10256 10.4135 8.51282 10.1059 8.92308 10.1059ZM15.0769 15.8479H8.92308C8.51282 15.8479 8.10256 15.5403 8.10256 15.0276C8.10256 14.5149 8.41026 14.2073 8.92308 14.2073H15.0769C15.4872 14.2073 15.8974 14.5149 15.8974 15.0276C15.8974 15.5403 15.4872 15.8479 15.0769 15.8479Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/Document.80d42a9b004d9de206f9608ca7f4e64f.svg";
export { ForwardRef as ReactComponent };